import { IMembro } from '@/@types/EstruturaOrganizacional';
import { ContainerMembros } from '@/components/shared/ContainerMembros';
import { Loading } from '@/components/shared/Loading';
import { MembroItem } from '@/components/shared/MembroItem';
import { api } from '@/services/api';
import { useEffect, useState } from 'react';

const ComposicaoCPESQ = () => {
    const [composicaoCPESQ, setComposicaoCPESQ] = useState<IMembro[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {

        const getComposicaoCPESQ = async () => {
            setIsLoading(true);
            const url = '/feagri/colegiados/orgao/sigla/CPESQ';

            await api.get(url)
                .then(response => {
                    setComposicaoCPESQ(response.data);
                })
                .catch(err => {
                    console.log(err)
                })
                .finally(() => setIsLoading(false));

        }

        getComposicaoCPESQ();

    }, []);

    return(
        <>
            <h1>Composição da Comissão de Pesquisa - CPESQ</h1>

            {isLoading ? (
                <Loading color='primary' />
            ) : (
                <ContainerMembros>
                    {composicaoCPESQ.map(representante => {
                        return (
                            <MembroItem key={representante._id} data={{
                                representanteFuncao: representante.funcao.funcaoweb,
                                representanteNome: representante.representante.nome,
                                representanteTitulo: representante.representante.funcao_representante,
                                representanteSubfuncao: representante.subfuncao?.subfuncaoweb,
                                foto: representante.representante.foto
                            }} />
                        );
                    })}
                </ContainerMembros>
            )}
        </>
    )
}

export { ComposicaoCPESQ };